import { render, staticRenderFns } from "./gradepie.vue?vue&type=template&id=2d375a01&"
import script from "./gradepie.vue?vue&type=script&lang=js&"
export * from "./gradepie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports